<template>
    <div class="footer">
        <div class="footerContent">
            <div class="contact">
                <div class="information">
                    <div class="jumpTo">
                        <div class="hotline">
                            <div class="logo">
                                <img class="logo_img" src="../../static/home/NR-logo.png" alt="logo"/>
                                <span>南软科技</span>
                            </div>
                            <div>
                                <span class="iconfont icon-dianhua hotlineImg"></span>
                                <span>免费客服热线：
                                    <span class="hotLineNum">4008-539-529</span>
                                </span>
                            </div> 
                        </div>
                        <ul class="ulOne">
                            <li ><a href="javascript:;" class="jumpToItem" @click="external('homepage')">产品介绍</a></li>
                            <li ><a href="javascript:;" class="jumpToItem" @click="external('aboutUsUs?activeIndex=2')">企业动态</a></li>
                            <li ><a href="javascript:;" class="jumpToItem" @click="interior(1)">联系我们</a></li>
                        </ul>
                        <ul class="ulTwo">
                            <li ><a href="javascript:;" class="jumpToItem" @click="external('Visual')">解决方案</a></li>
                            <li ><a href="javascript:;" class="jumpToItem" @click="interior(2)">企业简介</a></li>
                        </ul>
                    </div>
                </div>
                <div class="QRCode">
                    <div class="QR-container">
                        <div class="QR_img">
                            <img src="../../static/footer/wly.png"/>
                            <p>关注微信公众号</p>
                        </div>
                        <div class="QR_img">
                            <img src="../../static/footer/dy.png"/>
                            <p>关注抖音视频号</p>
                        </div>
                        <!-- <div class="QR_img">
                            <img src="../../static/footer/ks.png"/>
                            <p>关注快手视频号</p>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="copyright">
                <span v-if="type == 1">
                    Copyright@2017 湖南南软信息科技有限公司版权所有 <a href="https://beian.miit.gov.cn" style="color: #ffffff;">湘ICP备15002327号</a>
                </span>
                <span v-if="type == 2">
                    Copyright@2017 海南南软智能科技有限公司版权所有 <a href="https://beian.miit.gov.cn" style="color: #ffffff;">琼ICP备2020003487号</a>
                </span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:"footer-content",
    data() {
        return{
            type: sessionStorage.getItem('type')
        }
    },
    methods: {
        external (url) {
            window.open(this.$store.state.url + '/#/' + url, '_blank');
        },
        interior (type) {
            let scrollToVal = 0
            if (type == 1) {
                scrollToVal = 4600
            } else {
                scrollToVal = 1600
            }
            this.$router.push({ 
                name: 'aboutUsUs',
                query: {
                    scrollToVal:scrollToVal
                }
            })
        }
    }
}
</script>
<style lang="scss">
    .footer {
        ul {
            list-style: none;
            margin: 0;
            padding: 0;
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue